import formatDateTime from './formatDateTime';

/* Las funciones padre filterDataSource y filterDataDestination reciben data y formikValues
    - filterDataSource se utiliza en iDoc Origen con data siendo loads
    - filterDataDestination se utiliza en iDoc Destino con data siendo expeditions
    - filterDataTickets se utiliza en soporte con data siendo objetos personalizados
*/

const filterDataSource = (data, formikValues) => {
    return data
        .filter(load => filterDataCommercial(load.loadBoard, formikValues))
        .filter(load => filterDataProvider(load.loadBoard, formikValues))
        .filter(load => filterDataTrailer(load.loadBoard, formikValues))
        .filter(load => filterDataState(load.loadBoard, formikValues))
        .filter(load => filterDataNumRef(load.loadBoard, formikValues))
        .filter(load => filterDataHeadQuarter(load.loadBoard, formikValues))
}

const filterDataDestination = (data, formikValues) => {
    return data
        .filter(expedition => filterDataCommercial(expedition.expeditionBoard, formikValues))
        .filter(expedition => filterDataCustomer(expedition.expeditionBoard, formikValues))
        .filter(expedition => filterDataTrailer(expedition.expeditionBoard, formikValues))
        .filter(expedition => filterDataState(expedition.expeditionBoard, formikValues))
        .filter(expedition => filterDataNumRef(expedition.expeditionBoard, formikValues))
        .filter(expedition => filterDataHeadQuarter(expedition.expeditionBoard, formikValues))
}

const filterDataTickets = (data, formikValues) => {
    return data
        .filter(ticketRes => filterDataTicketId(ticketRes, formikValues))
        .filter(ticketRes => filterDataTicketUltMod(ticketRes, formikValues))
        .filter(ticketRes => filterDataTicketInstalacion(ticketRes, formikValues))
        .filter(ticketRes => filterDataTicketTipo(ticketRes, formikValues))
        .filter(ticketRes => filterDataTicketUsuario(ticketRes, formikValues))
        .filter(ticketRes => filterDataTicketAsunto(ticketRes, formikValues))
        .filter(ticketRes => filterDataTicketResponsable(ticketRes, formikValues))
        .filter(ticketRes => filterDataTicketEstado(ticketRes, formikValues))

    function filterDataTicketId(item, formikValues){
        if(formikValues.id != undefined){
            return (formikValues.id != "" ? String((item.ticket.caso)).toLowerCase().includes(String(formikValues.id).toLowerCase()) : true)
        }
        else{
            return true;
        }
    }

    function filterDataTicketUltMod(item, formikValues){
        if(formikValues.ultMod != undefined){
            return (formikValues.ultMod != "" ? String(formatDateTime(item.ticket.ultimaModificacion)).includes(String(formikValues.ultMod)) : true)
        }
        else{
            return true;
        }
    }

    function filterDataTicketInstalacion(item, formikValues){
        if(formikValues.instalacion != undefined){
            return (formikValues.instalacion != "*" ? item.instalacionUsuario == formikValues.instalacion : true)
        }
        else{
            return true;
        }
    }

    function filterDataTicketTipo(item, formikValues){
        if(formikValues.tipo != undefined){
            return (formikValues.tipo != "*" ? item.nombreTipo == formikValues.tipo : true)
        }
        else{
            return true;
        }
    }

    function filterDataTicketUsuario(item, formikValues){
        if(formikValues.usuario != undefined){
            return (formikValues.usuario != "*" ? item.nombreUsuario == formikValues.usuario : true)
        }
        else{
            return true;
        }
    }

    function filterDataTicketAsunto(item, formikValues){
        if(formikValues.asunto != undefined){
            return (
                formikValues.asunto != "" ? String(item.ticket.asunto).toLowerCase().includes(String(formikValues.asunto).toLowerCase()) : true)
        }
        else{
            return true;
        }
    }

    function filterDataTicketResponsable(item, formikValues){
        if(formikValues.responsable != undefined){
            return (formikValues.responsable != "*" ? item.nombreResponsable == formikValues.responsable : true)
        }
        else{
            return true;
        }
    }

    function filterDataTicketEstado(item, formikValues){
        if(formikValues.estado != undefined){
            if(formikValues.estado == "!CERRADO") { return item.ticket.estado != "CERRADO"; }
            else { return (formikValues.estado != "*" ? item.ticket.estado == formikValues.estado : true) }
        }
        else{
            return true;
        }
    }
}

function filterDataCommercial(item, formikValues){
    if(formikValues.commercial != undefined){
        return (formikValues.commercial != "*" ? item.managerId == formikValues.commercial : true)
    }
    else{
        return true;
    }
}

function filterDataProvider(item, formikValues){
    if(formikValues.provider != undefined){
        return (formikValues.provider != "*" ? item.providerId == formikValues.provider : true)
    }
    else{
        return true;
    }
}

function filterDataHeadQuarter(item, formikValues){
    if(formikValues.headQuarter != undefined){
        return (formikValues.headQuarter != '*' ? item.headQuarterId == formikValues.headQuarter : true)
    }
    else{
        return true;
    }
}

function filterDataCustomer(item, formikValues){
    if(formikValues.customer != undefined){
        return (formikValues.customer != "*" ? item.customerId == formikValues.customer : true)
    }
    else{
        return true;
    }
}

function filterDataTrailer(item, formikValues){
    if(formikValues.trailer != undefined){
        return (formikValues.trailer != "" ? String((item.trailer)).includes(String(formikValues.trailer)) : true)
    }
    else{
        return true;
    }
}

function filterDataState(item, formikValues){
    if(formikValues.state != undefined){
        return (formikValues.state != "*" ? item.status == formikValues.state : true)
    }
    else{
        return true;
    }
}

function filterDataNumRef(item, formikValues){
    if(formikValues.numRefWaybill != undefined){
        let srefs = [];
        
        if(item.reference != ""){
            srefs = item.reference.split(",");
        }

        return (formikValues.numRefWaybill != "" 
            ? srefs.find(sref => {
                if(sref.includes(formikValues.numRefWaybill)){
                    return true;
                }
            }) 
            : true
        )
    }
    else{
        return true;
    }
}

export { filterDataSource, filterDataDestination, filterDataTickets }
